import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.aside`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: flex;
    flex-direction: column;
    gap: ${space[5]};
    width: 280px;
    flex-shrink: 0;
  }
`;

export const Title = styled.h2`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const Card = styled.nav`
  background: ${colors.white};
  border: 1px solid ${semantic.border.subtle};
  border-radius: ${layout.borderRadiusLg};
  padding: ${space[2]};
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const NavItem = styled.button<{ $active?: boolean; $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  width: 100%;
  padding: ${space[3]} ${space[4]};
  background: ${({ $active }) => ($active ? semantic.bg.surfaceSubtle : 'transparent')};
  border: none;
  border-radius: ${layout.borderRadiusMd};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  color: ${({ $disabled }) => ($disabled ? semantic.text.tertiary : semantic.text.primary)};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${({ $active }) => ($active ? fonts.weight.semiBold : fonts.weight.normal)};
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ $disabled }) => ($disabled ? 'transparent' : semantic.bg.surfaceSubtle)};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    pointer-events: none;
  }
`;

export const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
`;

export const SignOutWrapper = styled.div`
  padding-left: ${space[2]};
`;
